import axios from 'axios';
import { GET_TEMPLATES } from './types';

export const getTemplates =
	(isEnterpriseRequested = false) =>
	async (dispatch) => {
		try {
			// includeGroupChat: this client filters by kind locally (TemplateSelector),
			// so it opts in to receiving group-chat templates; old clients don't
			const res = await axios.get(
				`/api/templates?isEnterpriseRequested=${isEnterpriseRequested}&includeGroupChat=true`
			);
			dispatch({ type: GET_TEMPLATES, payload: res.data });
			return res.data;
		} catch (err) {
			console.error('Error fetching templates:', err);
		}
	};
